import { setLocalData, getLocalData } from './cache'
import { REGION } from '@ms/config/app'

const M_SELECTIONS_BETS = 'M_SELECTIONS_BETS'

export const saveSelectionsBets = (key, value, type) => {
  const data = getLocalData(M_SELECTIONS_BETS, 'session')
  let _data
  if (data) {
    _data = data
    if (!_data[type]) _data[type] = {}
  } else {
    _data = {}
    _data[type] = {}
  }
  _data[type][key] = value
  setLocalData(M_SELECTIONS_BETS, _data, 'session')
}

export const getSelectionsBets = (key, type) => {
  const data = getLocalData(M_SELECTIONS_BETS, 'session')
  if (data) {
    const _data = data
    if (key) return _data[type] && _data[type][key] ? _data[type][key] : ''
    else return _data[type] ? _data[type] : ''
  }
  return null
}

export const removeSelectionsBets = (key = '', type = '') => {
  if (key && type) {
    const data = getLocalData(M_SELECTIONS_BETS, 'session')
    const _data = data
    if (_data[type] && String(_data[type][key])) {
      delete _data[type][key]
      setLocalData(M_SELECTIONS_BETS, _data, 'session')
    }
  } else {
    sessionStorage.removeItem(`${REGION}-${M_SELECTIONS_BETS}`)
  }
}
